import { TrackParameters } from '../models/TelemetryData';

/**
 * Parse a track .ini file into TrackParameters.
 * Expected format:
 * [PARAMETERS]
 * WIDTH=1357.31
 * HEIGHT=1042.15
 * etc.
 */
export function parseTrackIni(iniText: string): TrackParameters {
  const lines = iniText.split('\n');
  const params: Record<string, string> = {};

  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith('[')) continue;
    const eqIndex = trimmed.indexOf('=');
    if (eqIndex === -1) continue;
    const key = trimmed.substring(0, eqIndex).trim();
    const value = trimmed.substring(eqIndex + 1).trim();
    params[key] = value;
  }

  return {
    width: parseFloat(params['WIDTH'] || '0'),
    height: parseFloat(params['HEIGHT'] || '0'),
    margin: parseFloat(params['MARGIN'] || '0'),
    scaleFactor: parseFloat(params['SCALE_FACTOR'] || '1'),
    xOffset: parseFloat(params['X_OFFSET'] || '0'),
    zOffset: parseFloat(params['Z_OFFSET'] || '0'),
    drawingSize: parseFloat(params['DRAWING_SIZE'] || '10'),
  };
}

/**
 * Build the track asset filename from the gameTrack/gameLayout (AC folder names).
 * E.g., "ks_brands_hatch" + "indy" → "ks_brands_hatch_-_indy"
 */
export function getTrackAssetBaseName(gameTrack: string, gameLayout: string): string {
  return `${gameTrack}_-_${gameLayout}`.toLowerCase().replace(/\s+/g, '_');
}
